<template>
  <div v-if="groups && groups.length > 0" class="tags is-inline">
    <a @click="visible = !visible" class="is-unselectable">
      <IconText :icon="visible ? 'mdi-chevron-right' : 'mdi-chevron-left'"
        ><span>Groups</span>
      </IconText>
    </a>

    <transition name="slide-fade">
      <div v-if="visible" class="margin-left-10 is-inline">
        <router-link
          v-for="group of groups"
          :to="
            `/domains/${$route.params.domainUID}/groups/${group.uid}/packages`
          "
          :key="group.uid"
          class="tag"
        >
          <span class="icon-text">
            <span class="icon">
              <i class="mdi mdi-monitor-multiple"></i>
            </span>
            <span>{{ group.name }}</span>
          </span>
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: { IconText: () => import("@/components/singles/IconText.vue") },
  data() {
    return {
      groups: null,
      visible: false,
    };
  },

  async created() {
    this.$emit("loading", true);
    this.groups = await this.$store.dispatch("group/fetchComputerGroups", {
      domainUID: this.$route.params.domainUID,
      computerUID: this.$route.params.computerUID,
    });

    this.$emit("change", this.groups);
    this.$emit("loading", false);
  },
};
</script>
